<div *ngIf="config.description" [ngClass]="config.cssClassesDescription">
  {{ config.description }}
</div>
<div *ngIf="config.maxlength && config.maxlength > 0" [ngClass]="config.cssClassesDescription">
  <span>{{ 'Máxima longitud de campo: @max carácteres' | t: {'@max': config.maxlength} }}</span>
</div>
